"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AnalyticsProvider =
/** @class */
function () {
  function AnalyticsProvider(name) {
    this.name = name;
  }

  AnalyticsProvider.prototype.initialClick = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.tradeInStart = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.tradeInEstimate = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.tradeInComplete = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.calculationStart = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.calculationFinish = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.leadFormStart = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.leadFormFinish = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.appointmentScheduled = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.creditAppComplete = function (dealId, vehicle, applicationId) {// no-op
  };

  AnalyticsProvider.prototype.softPullCreditAppStart = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.hardPullCreditAppStart = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.softPullCreditAppComplete = function (dealId, vehicle, applicationId) {// no-op
  };

  AnalyticsProvider.prototype.hardPullCreditAppComplete = function (dealId, vehicle, applicationId) {// no-op
  };

  AnalyticsProvider.prototype.FAndIFinish = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.dropSave = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.buildNewPayment = function () {// no-op
  };

  AnalyticsProvider.prototype.signInToGarageGarageIcon = function (dealId) {// no-op
  };

  AnalyticsProvider.prototype.savesPayment = function () {// no-op
  };

  AnalyticsProvider.prototype.skipCreditApp = function () {// no-op
  };

  AnalyticsProvider.prototype.creditAppPrimaryPageTwo = function () {// no-op
  };

  AnalyticsProvider.prototype.cosignerYes = function () {// no-op
  };

  AnalyticsProvider.prototype.exploreUpgrades = function () {// no-op
  };

  AnalyticsProvider.prototype.skipUpgrades = function () {// no-op
  };

  AnalyticsProvider.prototype.continueDeal = function (vin) {// no-op
  };

  AnalyticsProvider.prototype.addUpgrade = function (id) {// no-op
  };

  AnalyticsProvider.prototype.pickDeliveryDate = function (date) {// no-op
  };

  AnalyticsProvider.prototype.pickDeliveryTime = function (time) {// no-op
  };

  AnalyticsProvider.prototype.paymentOfferSelected = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.reserveVehicleFormStart = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.reserveVehicleFormFinish = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.virtualPageView = function (pagePath) {// no-op
  };

  AnalyticsProvider.prototype.signInStart = function () {// no-op
  };

  AnalyticsProvider.prototype.signInComplete = function (dealId) {// no-op
  };

  AnalyticsProvider.prototype.paymentBuilderLoad = function (dealId, vehicle) {// no-op
  };

  AnalyticsProvider.prototype.paymentOptionsLoad = function (dealId, vehicle) {// no-op
  };

  return AnalyticsProvider;
}();

exports.AnalyticsProvider = AnalyticsProvider;
exports.default = AnalyticsProvider;